<template>
  <div class="xer-documentation">
    <p class="xer-text-s" v-html="rootStore.translate(content.beschrijving)"></p>

    <div v-for="(contact, index) in content.contacten" :key="index" class="xer-flex xer-flex-col">
      <span
        v-if="contact.title"
        class="xer-text-s xer-font-medium xer-mb-2"
        data-automation-id="contact-title"
        v-html="rootStore.translate(contact.title)"
      ></span>

      <a
        v-if="contact.telefoonnummer"
        :href="`tel: ${rootStore.translate(contact.telefoonnummer)}`"
        class="xer-text-s"
        data-automation-id="contact-tel"
      >
        <xer-icon xer-name="telephone" xer-color="primary" class="xer-mr-3"> </xer-icon>
        <span v-html="rootStore.translate(contact.telefoonnummer)"></span>
      </a>

      <a
        v-if="contact.email"
        :href="`
          mailto: ${rootStore.translate(contact.email)}?Subject=${encodeURI(
          rootStore
            .translate('Moez.Contacteerons.Mail.Onderwerp')
            .replace('{aanbod-naam}', content.aanbodNaam ? content.aanbodNaam : '')
        )}`"
        class="xer-text-s xer-mb-5"
        data-automation-id="contact-mail"
      >
        <xer-icon xer-name="mail" xer-color="primary" class="xer-mr-3"></xer-icon>
        <span v-html="rootStore.translate(contact.email)"></span>
      </a>
    </div>

    <!-- BACK-COMPAT old definities do not have contacten array yet-->
    <div class="xer-flex xer-flex-col">
      <a
        v-if="!content.contacten"
        :href="`tel: ${rootStore.translate(content.telefoon)}`"
        class="xer-text-s"
        data-automation-id="contact-tel"
      >
        <xer-icon xer-name="telephone" xer-color="primary" class="xer-mr-3"> </xer-icon>
        <span v-html="rootStore.translate(content.telefoon)"></span>
      </a>

      <a
        v-if="!content.contacten"
        :href="`
          mailto: ${rootStore.translate(content.email)}?Subject=${encodeURI(
          rootStore
            .translate('Moez.Contacteerons.Mail.Onderwerp')
            .replace('{aanbod-naam}', content.aanbodNaam ? content.aanbodNaam : '')
        )}`"
        class="xer-text-s"
        data-automation-id="contact-mail"
      >
        <xer-icon xer-name="mail" xer-color="primary" class="xer-mr-3"></xer-icon>
        <span v-html="rootStore.translate(content.email)"></span>
      </a>
    </div>
    <!-- END BACK-COMPAT -->
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useRootStore } from '@/stores';

export default {
  props: {
    content: {
      type: Object,
      default: () => ({
        beschrijving: '',
        aanbodNaam: '',
        email: '',
        telefoon: '',
        contacten: []
      })
    }
  },
  computed: {
    ...mapStores(useRootStore)
  }
};
</script>
